/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Settings_VibrateInputs */

const en_us2_workout_logging_settings_vibrate = /** @type {(inputs: Workout_Logging_Settings_VibrateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibrate when the rest is over`)
};

const pt_br2_workout_logging_settings_vibrate = /** @type {(inputs: Workout_Logging_Settings_VibrateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibrar no fim do descanso`)
};

const es_419_workout_logging_settings_vibrate = /** @type {(inputs: Workout_Logging_Settings_VibrateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibrar al terminar el descanso`)
};

const pt_pt2_workout_logging_settings_vibrate = /** @type {(inputs: Workout_Logging_Settings_VibrateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibrar no fim do descanso`)
};

const fr_fr2_workout_logging_settings_vibrate = /** @type {(inputs: Workout_Logging_Settings_VibrateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibrer à la fin du repos`)
};

const de_de2_workout_logging_settings_vibrate = /** @type {(inputs: Workout_Logging_Settings_VibrateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibrieren bei Pausenende`)
};

const it_it2_workout_logging_settings_vibrate = /** @type {(inputs: Workout_Logging_Settings_VibrateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibra a fine recupero`)
};

/**
* | output |
* | --- |
* | "Vibrate when the rest is over" |
*
* @param {Workout_Logging_Settings_VibrateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_settings_vibrate = /** @type {((inputs?: Workout_Logging_Settings_VibrateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Settings_VibrateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_settings_vibrate(inputs)
	if (locale === "es-419") return es_419_workout_logging_settings_vibrate(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_settings_vibrate(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_settings_vibrate(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_settings_vibrate(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_settings_vibrate(inputs)
	return en_us2_workout_logging_settings_vibrate(inputs)
});
export { workout_logging_settings_vibrate as "workout-logging.settings_vibrate" }